import React from 'react';
import PropTypes from 'prop-types';
import { InputField, ErrorMessage } from 'anf-core-react';

export default function FirstAndLastNameInputFields({
  text,
  firstName,
  setFirstName,
  firstNameIsInvalid,
  lastName,
  setLastName,
  lastNameIsInvalid,
}) {
  const { formFieldFirstName, formFieldLastName } = text;

  const nameIsInvalid = firstNameIsInvalid || lastNameIsInvalid;
  const firstLastNameError = formFieldFirstName?.error?.value || formFieldLastName?.error?.value;
  const errorKey = formFieldFirstName?.error?.key || formFieldLastName?.error?.key;

  return (
    <>
      <div className="customer-email-us-form__name-fields">
        <InputField
          autoComplete="first-name"
          id="customer-email-us-form__first-name"
          isInvalid={firstNameIsInvalid}
          isRequired
          label={formFieldFirstName?.label?.value}
          name="firstName"
          onChange={(e) => setFirstName(e.target.value)}
          type="text"
          value={firstName}
        />
        <InputField
          autoComplete="last-name"
          id="customer-email-us-form__last-name"
          isInvalid={lastNameIsInvalid}
          isRequired
          label={formFieldLastName?.label?.value}
          name="lastName"
          onChange={(e) => setLastName(e.target.value)}
          type="text"
          value={lastName}
        />
      </div>
      {nameIsInvalid && firstLastNameError && (
        <ErrorMessage variant="error">
          <span data-property={errorKey}>
            {firstLastNameError}
          </span>
        </ErrorMessage>
      )}
    </>
  );
}

FirstAndLastNameInputFields.propTypes = {
  text: PropTypes.shape({
    formFieldFirstName: PropTypes.shape({
      label: PropTypes.shape({
        value: PropTypes.string.isRequired,
      }).isRequired,
      error: PropTypes.shape({
        value: PropTypes.string,
        key: PropTypes.string,
      }),
    }),
    formFieldLastName: PropTypes.shape({
      label: PropTypes.shape({
        value: PropTypes.string.isRequired,
      }).isRequired,
      error: PropTypes.shape({
        value: PropTypes.string,
        key: PropTypes.string,
      }),
    }),
  }).isRequired,
  firstName: PropTypes.string,
  setFirstName: PropTypes.func.isRequired,
  firstNameIsInvalid: PropTypes.bool,
  lastName: PropTypes.string,
  setLastName: PropTypes.func.isRequired,
  lastNameIsInvalid: PropTypes.bool,
};

FirstAndLastNameInputFields.defaultProps = {
  firstName: '',
  firstNameIsInvalid: false,
  lastName: '',
  lastNameIsInvalid: false,
};
